import _ from 'lodash';
import { useMemo } from 'react';

function CheckboxWithEmoji({
  emoji,
  label,
  checked,
  disabled = checked,
  onClick = (e) => {},
}: {
  emoji: string;
  label: string;
  checked: boolean;
  disabled?: boolean;
  onClick?: (e: Event) => void;
}) {
  const debouncedOnClick = useMemo(
    () =>
      _.debounce((e) => {
        if (!disabled) {
          onClick(e);
        }
      }, 500),
    [onClick, disabled],
  );
  return (
    <div
      onClick={debouncedOnClick}
      role="button"
      className="relative flex-none bg-theme-background w-[150px] h-[100px] border-dashed border border-brand-main flex flex-col items-center justify-center"
    >
      <span className="text-xl">{emoji}</span>
      <span className="px-3 text-center text-theme-main">{label}</span>
      <input
        type="checkbox"
        className="absolute top-[8px] right-[8px] w-[24px] h-[24px]"
        checked={checked}
        disabled
      />
    </div>
  );
}

export default CheckboxWithEmoji;
